/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ContainerLocationPhysicalStatusListQueryVariables = {};
export type ContainerLocationPhysicalStatusListQueryResponse = {
    readonly v2PhysicalStatusList: ReadonlyArray<{
        readonly slug: string;
        readonly name: string;
    }>;
};
export type ContainerLocationPhysicalStatusListQuery = {
    readonly response: ContainerLocationPhysicalStatusListQueryResponse;
    readonly variables: ContainerLocationPhysicalStatusListQueryVariables;
};



/*
query ContainerLocationPhysicalStatusListQuery {
  v2PhysicalStatusList {
    slug
    name
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PhysicalStatusResult",
    "kind": "LinkedField",
    "name": "v2PhysicalStatusList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContainerLocationPhysicalStatusListQuery",
    "selections": (v0/*: any*/),
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ContainerLocationPhysicalStatusListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "290af308b70081ab087520817d6736c5",
    "id": null,
    "metadata": {},
    "name": "ContainerLocationPhysicalStatusListQuery",
    "operationKind": "query",
    "text": "query ContainerLocationPhysicalStatusListQuery {\n  v2PhysicalStatusList {\n    slug\n    name\n  }\n}\n"
  }
};
})();
(node as any).hash = '5e17a912a57350d949b77c4716dfa017';
export default node;
